import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHSixtyFivePreLogin',
    name: 'IFPageOneHSixtyFivePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtyFiveLogin' ||
        from.path === '/IFPageOneHSixtyFiveLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtyFiveLogin',
    name: 'pageOneHSixtyFiveLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyFiveLoginLoading',
    name: 'pageOneHSixtyFiveLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyFiveLeaveInfo',
    name: 'pageOneHSixtyFiveLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyFiveResult',
    name: 'pageOneHSixtyFiveResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyFiveLoading',
    name: 'pageOneHSixtyFiveLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtyFiveLoginSecond',
    name: 'pageOneHSixtyFiveLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyFiveOnline',
    name: 'pageOneHSixtyFiveOnline',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHSixtyFiveLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHSixtyFiveGuide',
    name: 'pageOneHSixtyFiveLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
      path: '/IFPageOneHSixtyFiveCar',
      name: 'pageOneHSixtyFiveCar',
      component: () => import('@/pages/pageListAll/pageOneHSixtyFive/car.vue'),
      meta: {
        title: '补充留资',
      },
    },
    {
      path: '/IFPageOneHSixtyFiveCarDetails',
      name: 'pageOneHSixtyFiveCarDetails',
      component: () => import('@/pages/pageListAll/pageOneHSixtyFive/carDetails.vue'),
      meta: {
        title: '申请结果',
      },
    },*/
  {
    path: '/IFPageOneHSixtyFiveBlank',
    name: 'pageOneHSixtyFiveBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyFiveOnlineTab',
    name: 'pageOneHSixtyFiveOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyFiveOnlineAd',
    name: 'pageOneHSixtyFiveOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHSixtyFive/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
